/* eslint-disable */
import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({

  firstChildren: () => ({
    zIndex: 2,
    position: 'relative',
    whiteSpace: "nowrap"
  }),

  otherChildren: ({position}) => {
    let style = {};
    switch(position){
      case "rightBottom": style.right=0;break;
      case "leftBottom": style.left=0;break;
    }

    return {
      whiteSpace: "nowrap",
      zIndex: 1,
      position: 'absolute',
      MsTransition: 'all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
      WebkitTransition: 'all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
      transition: 'all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
      right:0,
    };
  },

  position: ({ position }) => {
    switch (position) {
      case "rightBottom":
        return { right: 0, bottom: 0 };
      case "rightTop":
        return { right: 0, top: 0 };
      case "leftBottom":
        return { left: 0, bottom: 0 };
      case "leftTop":
        return { left: 0, top: 0 };
    }
  },

  offset: ({ offset }) => ({
    margin: offset
  }),

  fixed: () => ({
    position: 'fixed',
    zIndex: 999999
  })
}));

// Index component
const FloatButton = ({
  margin,
  children,
  className,
  delay,
  position,
  offset
}) => {

  const [show, setShow] = useState(false);

  const classes = useStyles({ offset, position});

  const showUpdate = () => {
    setShow(!show);
  };

  const getChildrenStyle = (i) => {
    return {
      bottom: show ? margin * i : 0,
      opacity: show ? 1 : 0,
      visibility: show ? 'visible' : 'hidden',
      MsTransitionDelay: `${i * delay}s`,
      WebkitTransitionDelay: `${i * delay}s`,
      transitionDelay: `${i * delay}s`,
      MsTransform: `scale(${show ? 1 : 0}, ${show ? 1 : 0})`,
      WebkitTransform: `scale(${show ? 1 : 0}, ${show ? 1 : 0})`,
      transform: `scale(${show ? 1 : 0}, ${show ? 1 : 0})`,
    };
  }

  return (
    <div className={clsx(classes.position, classes.offset, className, classes.fixed)}>
      {
        Object.prototype.toString.call(children) === '[object Array]' &&
        children.map((item, i) => {
          if (i === 0) {
            return (
              <div
                key={`float-btn-${i}`}
                tabIndex={0}
                role="button"
                className={classes.firstChildren}
                onClick={showUpdate}
              >
                {item}
              </div>
            );
          }

          return (
            <div
              key={`float-btn-${i}`}
              tabIndex={-1}
              role="button"
              className={classes.otherChildren}
              style={getChildrenStyle(i)}
              onClick={showUpdate}
            >
              {item}
            </div>
          );
        })
      }
    </div>
  );
};

// FloatButton.propTypes = {
//   margin: PropTypes.number,
//   children: PropTypes.array.isRequired, // eslint-disable-line
//   style: PropTypes.obj,
// };

FloatButton.defaultProps = {
  margin: 50,
  children: [],
  className: "",
  delay: 0.03,
  position: "rightBottom"
};

FloatButton.rightBottomProps = {
  offset: '0 10px 70px 0',
  margin: 50,
  delay: 0.02
};

export default FloatButton;